module.exports = __webpack_public_path__ + "static/media/Maf_TheThree.062beb8a.jpg";